import SmartphoneIcon from '@mui/icons-material/Smartphone';
import { Button, Stack } from '@mui/material';
import { ReactNode, useState } from 'react';

import { Dialog } from 'components/Dialog';
import { PhoneFrame } from './PhoneFrame';

interface AppPreviewProps {
  children?: ReactNode;
  src?: string;
  label?: string;
  size?: 'small' | 'medium' | 'large';
  variant?: 'text' | 'outlined' | 'contained';
  fullWidth?: boolean;
}

export const AppPreview = ({
  children,
  src,
  label = 'Приложение',
  size,
  variant = 'outlined',
  fullWidth,
}: AppPreviewProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant={variant}
        size={size}
        fullWidth={fullWidth}
        startIcon={<SmartphoneIcon />}
        onClick={() => setOpen(true)}
        sx={{ textTransform: 'none' }}
      >
        {label}
      </Button>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        hideFooter
        width="500px"
        header="Предпросмотр в приложении"
        main={
          <Stack sx={{ paddingY: 2 }}>
            <PhoneFrame src={src}>{children}</PhoneFrame>
          </Stack>
        }
      />
    </>
  );
};
